module.exports = __webpack_public_path__ + "static/hero-about-large-abf9c5ab14f93002f4c7fe3840df970e.png";